import type { ReactNode } from 'react';

import { STAGGER_MS } from '@/utils/animationConstants';

interface AnimateInProps {
	children: ReactNode;
	delay?: number;
	direction?: 'down' | 'right';
	className?: string;
}

export const AnimateIn = ({
	children,
	delay = 0,
	direction = 'down',
	className,
}: AnimateInProps) => {
	const animationName =
		direction === 'right' ? 'space-fade-in-right' : 'space-fade-in-down';

	return (
		<div
			className={className}
			style={{
				animationName,
				animationDuration: '400ms',
				animationTimingFunction: 'ease-out',
				animationFillMode: 'both',
				animationDelay: `${delay * STAGGER_MS}ms`,
			}}
		>
			{children}
		</div>
	);
};
